import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-delivery-bar',
  templateUrl: './deleivery-bar.component.html',
  styleUrls: ['./deleivery-bar.component.scss']
})
export class DeleiveryBarComponent implements OnInit, OnChanges {
  @Input() dispatchDateTime!: Date;
  @Input() expectedDeliveryDateTime!: Date;

  currentDate: Date = new Date();
  progress: number = 0;
  progressBarColor: string = '';
  truckIconColor: string = '';
  statusText: string = '';
  truckIcon: string = '';

  constructor() {}

  ngOnInit() {
    this.updateProgress();
  }

  ngOnChanges() {
    this.updateProgress();
  }

  updateProgress() {
    let dispatchDate: Date;
    let expectedDeliveryDate: Date;

    if (this.dispatchDateTime instanceof Date) {
      dispatchDate = this.dispatchDateTime;
    } else {
      dispatchDate = new Date(this.dispatchDateTime);
    }

    if (this.expectedDeliveryDateTime instanceof Date) {
      expectedDeliveryDate = this.expectedDeliveryDateTime;
    } else {
      expectedDeliveryDate = new Date(this.expectedDeliveryDateTime);
    }

    const currentMillis = this.currentDate.getTime();
    const dispatchMillis = dispatchDate.getTime();
    const deliveryMillis = expectedDeliveryDate.getTime();

    const millisToDaysAndHours = (millis: number) => {
      const totalHours = Math.ceil(millis / (1000 * 60 * 60));
      const days = Math.floor(totalHours / 24);
      const hours = totalHours % 24;
      return { days, hours };
    };

    if (currentMillis < dispatchMillis) {
      this.progress = 0;
      this.progressBarColor = 'red';
      this.truckIconColor = 'red';
      this.truckIcon = 'fas fa-truck';
      const dispatchTimeDiff = millisToDaysAndHours(dispatchMillis - currentMillis);
      this.statusText = `${dispatchTimeDiff.days} days & ${dispatchTimeDiff.hours} hrs to dispatch`;
    } else if (currentMillis >= dispatchMillis && currentMillis < deliveryMillis) {
      const totalMillis = deliveryMillis - dispatchMillis;
      const elapsedMillis = currentMillis - dispatchMillis;
      this.progress = Math.floor((elapsedMillis / totalMillis) * 100);
      this.progressBarColor = 'orange';
      this.truckIconColor = 'orange';
      this.truckIcon = 'fas fa-truck-fast';
      const deliveryTimeDiff = millisToDaysAndHours(deliveryMillis - currentMillis);
      this.statusText = `${deliveryTimeDiff.days} days & ${deliveryTimeDiff.hours} hrs to delivery`;
    } else {
      this.progress = 100;
      this.progressBarColor = 'green';
      this.truckIconColor = 'green';
      this.statusText = 'Delivered';
      this.truckIcon = 'fas fa-truck-ramp-box';
    }
  }

}
